export default __webpack_public_path__ + "media/images/formation-16-c741c63a1f8bb430a9f9433ff263e970.png";